export default __webpack_public_path__ + "alberta-clock.cdc80efd70773b587dcb.svg";